import { PRODUCTION_HOSTS, STAGING_HOSTS, DEV_HOSTS, LOCAL_HOSTS } from './hosts'
import setupAppInsights from './setupAppInsights'
import printFunctionCall from './printFunctionCall'

const { hostname } = window.location
const shouldTrack = [...PRODUCTION_HOSTS, ...STAGING_HOSTS, ...DEV_HOSTS].includes(hostname)
const shouldDisplay = process.env.DEBUG_ANALYTICS || [...DEV_HOSTS, LOCAL_HOSTS].includes(hostname)

export const appInsights = shouldTrack ? setupAppInsights(process.env.APP_INSIGHTS_TRACKING_ID || 'SKIP') : null

const track = (eventName: string, props?: Record<string, unknown>): void => {
    if (shouldDisplay) printFunctionCall('gtag', [eventName, props])
}

track.pageView = (props: { title: string; location?: string; path?: string }) => {
    appInsights?.trackPageView({
        name: props.title || document.title,
        uri: props.location || window.location.href,
    })
}

export default track
